import {PlatformDrawer} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {ProductFormValues} from '../types';

type FormDrawerProps = {
    title: string,
    initialValues: ProductFormValues,
    handleSubmit: (values: ProductFormValues) => Promise<unknown>,
    opened: boolean,
    onClose: () => void,
};

export const FormDrawer = ({title, initialValues, handleSubmit, opened, onClose}: FormDrawerProps) => {

    // Close only after the save has settled OK. If the API refuses (a
    // ConflictError, say) the await throws, onClose never runs, and the drawer
    // stays open with the operator's values; the hook has already shown why.
    const handleFormSubmit = async (values: ProductFormValues) => {
        await handleSubmit(values);
        onClose();
    };

    // Unsaved changes, decided deliberately: Escape, the close button and Cancel
    // all discard the form without a prompt, the same as every other drawer in
    // this app. A draft is the cheap thing to lose here; nothing reaches the API
    // until Save, and a confirm on every dismiss would get in the way of the
    // common case. Revisit if operators report losing long multi-unit entries.
    return (
        <PlatformDrawer opened={opened} onClose={onClose} title={title}>
            <RecordForm
                initialValues={initialValues}
                onSubmit={handleFormSubmit}
                onCancel={onClose}
            />
        </PlatformDrawer>
    );
};
